<template>
  <div>
    <div
      v-bind:style="{ borderColor: pcColor }"
      id="skill"
      class="skill-single"
      :class="{border:printSkill}"
    >
      <div class="row skill-text">
        <div style="padding-right:6rem">
          <div class="">{{ info.skill_name }}</div>
          <div class="resume-view-details" style="margin-top:0">{{ skillLevel }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "skill-edit",
  components: {},
  props: {
    skill: Object,
    index: Number,
    print: {
      type:Boolean,
      default:false
    }
  },
  data: function() {
    return {
      info: this.skill,
      level: null,
      skillLevel: null,
      prColor: null,
      pcColor: null,
      printSkill:this.print
    };
  },
  mounted: function() {
    const self = this;
    if (self.skill) {
      self.level = self.skill.skill_level;
      switch (self.level) {
        case 1:
          self.skillLevel = "Beginner";
          self.prColor = "#fff2f2";
          self.pcColor = "#C82333";
          break;
        case 2:
          self.skillLevel = "Intermediate";
          self.prColor = "papayawhip";
          self.pcColor = "goldenrod";
          break;
        case 3:
          self.skillLevel = "Professional";
          self.prColor = "#EAEEFD";
          self.pcColor = "#3b32ef";
          break;
        case 4:
          self.skillLevel = "Advanced";
          self.prColor = "#ede6fd";
          self.pcColor = "#6752f2";
          break;
        case 5:
          self.skillLevel = "Expert";
          self.prColor = "#D4EDDA";
          self.pcColor = "#155724";
          break;
      }
    }
  }
};
</script>

<style scoped>
.skill-single {
  padding: 0.9rem;
  padding-left:1.5rem ;
  background-color: #f2f3f8;
  float: left;
  margin: 1rem;
  margin-left:0 ;
  border-radius: 0.4rem;
}
.image-wrapper {
  text-align: left;
  margin-top: 1rem;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.skill {
  font-size: 1.6rem;
  font-weight: bold;
}
.skill-text {
  text-align: left;
}
.level {
  font-size: 1.4rem;
  color: #000000;
}
</style>
